import { create } from "zustand";

interface Message {
  id?: string;
  message_id?: string;
  role?: string;
  content?: string;
  message_type: string;
  attachments?: {
    additional_files: string[];
  };
  data: { content: string };
  sources?: any;
}

interface ChatpageStore {
  messages: Message[];
  currentConversationId: string;
  stopMessageId: string;
  fileError: string;
  clearMessages: () => void;
  addMessage: (newMessage: Message) => void;
  popMessage: () => void;
  setCurrentConversationId: (id: string) => void;
  setStopMessageId: (id: string) => void;
  setFileError: (error: string) => void;
}

const useChatpageStore = create<ChatpageStore>((set) => ({
  messages: [],
  currentConversationId: "",
  stopMessageId: "",
  fileError: "",
  clearMessages: () => {
    set({ messages: [] });
  },
  addMessage: (newMessage: Message) =>
    set((state) => ({
      messages: [...state.messages, newMessage],
    })),
  popMessage: () => {
    set((state) => ({
      messages: state.messages.slice(0, -2),
    }));
  },
  setCurrentConversationId: (id: string) => {
    set({ currentConversationId: id });
  },
  setStopMessageId: (id: string) => {
    set({ stopMessageId: id });
  },
  setFileError: (error: string) => {
    set({ fileError: error });
  },
}));

export default useChatpageStore;
